import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('click', function(event) {
        if (event.target.tagName === 'A' && event.target.getAttribute('href').startsWith('#')) {
            event.preventDefault();

            const targetId = event.target.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                // scroll-padding-topを考慮した位置を計算
                const scrollPaddingTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-top'), 10) || 0;
                const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - scrollPaddingTop;

                // GSAPを使用してスムーズスクロール
                gsap.to(window, {duration: 0.5, scrollTo: {y: targetPosition, autoKill: false}});
            }
        }
    });
});
